"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriveHttpDownloadResult = exports.HttpTransferChunk = exports.DriveHttpClient = exports.DriveClientVersion = void 0;
var shared_1 = require("../shared");
var runnable_1 = require("../../common/runnable");
var url_1 = require("../../utils/url");
var objects_1 = require("../../utils/objects");
var string_1 = require("../../utils/string");
var errors_1 = require("../../common/errors");
var promise_1 = require("../../utils/promise");
var namesHelper_1 = require("../namesHelper");
var cancel_1 = require("../../common/cancel");
var object_1 = require("../../common/object");
var guid_1 = require("../../utils/guid");
var DEFAULT_MIME_TYPE = "text/plain";
var makeContentType = function (mime, charset) {
    var DEFAULT_CHARSET = "charset=utf-8";
    return "".concat(mime || DEFAULT_MIME_TYPE, ";").concat(charset || DEFAULT_CHARSET);
};
var DriveClientVersion;
(function (DriveClientVersion) {
    DriveClientVersion[DriveClientVersion["Unknown"] = 0] = "Unknown";
    DriveClientVersion[DriveClientVersion["Initial"] = 1] = "Initial";
    DriveClientVersion[DriveClientVersion["SupportQueryUrl"] = 2] = "SupportQueryUrl";
})(DriveClientVersion || (exports.DriveClientVersion = DriveClientVersion = {}));
var DriveHttpClient = /** @class */ (function (_super) {
    __extends(DriveHttpClient, _super);
    function DriveHttpClient(apiUrl, clientIdentity, httpClient) {
        var _this = _super.call(this, "DriveHttpClient") || this;
        _this.apiUrl = apiUrl;
        _this.clientIdentity = clientIdentity;
        _this.httpClient = httpClient;
        _this.taskPool = new runnable_1.TaskPool(4);
        return _this;
    }
    DriveHttpClient.prototype.uploadContent = function (name, data, options, token, progress) {
        var _this = this;
        var relativeUri = "contents";
        options = options || {};
        relativeUri = (0, url_1.setUrlParam)(relativeUri, "name", name);
        if (options.replaceIfExists) {
            relativeUri = (0, url_1.setUrlParam)(relativeUri, "replace-if-exists", options.replaceIfExists);
        }
        if (options.daysToLive) {
            relativeUri = (0, url_1.setUrlParam)(relativeUri, "days-to-live", options.daysToLive);
        }
        var headers = { "Content-Type": makeContentType(options.mimeType) };
        // todo implicit type
        return this.send("PUT", relativeUri, data, null, headers, token, progress).then(function (response) {
            var res = {
                name: response.data && response.data.Name,
                url: response.headers["Location"] || response.headers["location"],
            };
            return res;
        }, function (e) {
            if ((0, cancel_1.isCancellationError)(e))
                throw e;
            var response = e.response;
            if (!response)
                return Promise.reject(_this.noResponseError(e));
            if (response.status === 409) {
                if (options.path && !options.replaceIfExists)
                    return Promise.reject(new shared_1.DriveConflictError(options.path));
                var url = namesHelper_1.DriveNamesHelper.buildContentUrlByName(_this.apiUrl, name);
                var res = { name: name, url: url };
                return (0, promise_1.promiseResolve)(res);
            }
            var msg = "DriveHttpClient - uploadContent - request failed with code ".concat(response.status);
            var error = new errors_1.CommonError(msg, null, errors_1.ErrorCodes.HttpError, response);
            return Promise.reject(error);
        });
    };
    DriveHttpClient.prototype.initPartialUpload = function (name, options, token, progress) {
        var _this = this;
        var uploadId = (0, guid_1.newGuid)();
        var relativeUri = "contents/js/initPartialUpload-v2";
        relativeUri = (0, url_1.setUrlParam)(relativeUri, "UploadId", uploadId);
        options = options || {};
        if (options.replaceIfExists) {
            relativeUri = (0, url_1.setUrlParam)(relativeUri, "replace-if-exists", options.replaceIfExists);
        }
        if (options.daysToLive) {
            relativeUri = (0, url_1.setUrlParam)(relativeUri, "days-to-live", options.daysToLive);
        }
        var headers = { "Content-Type": "application/json" };
        var body = {
            Name: name,
            Type: makeContentType(options.mimeType),
        };
        var transferChunk = new HttpTransferChunk(body);
        return this.send("POST", relativeUri, transferChunk, null, headers, token, progress).then(function (response) {
            var initResult = response.data;
            if (!initResult ||
                initResult !== Object(initResult) ||
                !initResult.UploadSessionId) {
                return Promise.reject(_this.noResponseError());
            }
            return initResult;
        }, function (e) {
            var response = e.response;
            if (!response)
                return Promise.reject(_this.noResponseError(e));
            if (response.status === 409) {
                if (response.data &&
                    response.data.Error.endsWith("already initialized")) {
                    // В каких-то случаях запрос инициализации доходит до драйва, но ответ не доходит до браузера.
                    // Браузер сам ретраит запрос и получает конфликт. Можно воспроизвести, если перехватить первый запрос фиддлером и грохнуть.
                    _this.log.warn("Upload already initialized", {
                        uploadId: uploadId,
                        name: name,
                    });
                    return Promise.reject(e);
                }
                if (options.path && !options.replaceIfExists)
                    return Promise.reject(new shared_1.DriveConflictError(options.path));
                var res = {
                    Conflict: true,
                    Name: name,
                };
                return (0, promise_1.promiseResolve)(res);
            }
            return Promise.reject(e);
        });
    };
    DriveHttpClient.prototype.uploadContentPart = function (data, options, token, progress) {
        // todo check parameters
        var _this = this;
        var relativeUri = "contents/js/parts?sessionid=".concat(options.sessionId);
        var to = Math.min(options.bytesTo, options.bytesTotal);
        var range = "bytes ".concat(options.bytesFrom, "-").concat(to - 1, "/").concat(options.bytesTotal || "*");
        var headers = { "Content-Range": range };
        return this.send("PUT", relativeUri, data, null, headers, token, progress).then(function (response) {
            var loweredHeaders = (0, objects_1.lowerObjectKeys)(response.headers);
            if (response.status === 201) {
                return {
                    driveContentUrl: loweredHeaders["location"],
                };
            }
            else if ((response.status = 200)) {
                return {};
            }
        }, function (e) {
            if ((0, cancel_1.isCancellationError)(e))
                throw e;
            var response = e.response;
            if (!response)
                return Promise.reject(_this.noResponseError(e));
            if (response.status === 409)
                return (0, promise_1.promiseResolve)({ conflict: true });
            var msg = "DriveHttpClient.uploadContentPart - request failed with code ".concat(response.status);
            var error = new errors_1.CommonError(msg, null, errors_1.ErrorCodes.HttpError, response);
            return Promise.reject(error);
        });
    };
    DriveHttpClient.prototype.getContentMeta = function (contentName) {
        var relativeUri = "contents/metadata_v2";
        relativeUri = (0, url_1.setUrlParam)(relativeUri, "name", contentName);
        return this.send("GET", relativeUri).then(function (x) {
            if (x.status === 200 && (0, objects_1.isObject)(x.data)) {
                var result = x.data;
                return {
                    name: result["_name"],
                    createdAtUTC: result["_createdAt"],
                    uid: result["_uid"],
                    namespaceId: result["_namespaceId"],
                    size: result["_size"],
                    srv: result["_srv"],
                    mimeType: result["_mimeType"],
                };
            }
            throw Error("Bad response. Retry");
        });
    };
    DriveHttpClient.prototype.downloadContent = function (options, token, progress) {
        var relativeUri = "contents";
        relativeUri = (0, url_1.setUrlParam)(relativeUri, "name", options.name);
        var headers = {};
        if (options.offset !== undefined && options.count !== undefined)
            headers = {
                Range: "bytes=".concat(options.offset, "-").concat(options.offset + options.count - 1),
            };
        var httpResponseType = options.responseType;
        if (options.responseType === "base64") {
            relativeUri = (0, url_1.setUrlParam)(relativeUri, "te", "base64");
            relativeUri = (0, url_1.setUrlParam)(relativeUri, "as", encodeURIComponent("text/plain; charset=utf-8"));
            httpResponseType = null;
        }
        var sendPromise = this.send("GET", relativeUri, null, httpResponseType, headers, token, progress);
        return (0, promise_1.using)(sendPromise, function (response) {
            var headersLowered = (0, objects_1.lowerObjectKeys)(response.headers);
            var r = new DriveHttpDownloadResult();
            r.content = response.data;
            r.isEncoded = headersLowered["content-transfer-encoding"] === "base64";
            var range = headersLowered["content-range"];
            if (range) {
                var matches = (0, string_1.namedRegexMatch)(range, /bytes (\d+)-(\d*)\/(\d*)/gi, [
                    "from",
                    "to",
                    "total",
                ]);
                r.from = parseInt(matches["from"]);
                r.to = parseInt(matches["to"]);
                r.total = parseInt(matches["total"]);
            }
            else if (response.status === 206) {
                throw new errors_1.CommonError("Can't determine content-range because empty header. Probably proxy-server issue.");
            }
            return (0, promise_1.promiseResolve)(r);
        });
    };
    DriveHttpClient.prototype.deleteContent = function (name) {
        var relativeUri = "contents";
        relativeUri = (0, url_1.setUrlParam)(relativeUri, "name", name);
        return this.send("DELETE", relativeUri);
    };
    DriveHttpClient.prototype.send = function (method, path, httpChunk, responseType, headers, token, progress) {
        var _this = this;
        token && token.throwIfCancelled();
        var url = (0, url_1.combineUrls)(this.apiUrl, path);
        var clientIdentity = this.clientIdentity;
        headers = headers || {};
        headers["Accept"] = "application/json";
        headers["Cache-Control"] = "no-cache, no-store, no-transform";
        headers["Content-Type"] =
            headers["Content-Type"] || headers["Content-type"] || makeContentType();
        if (httpChunk) {
            if (httpChunk.version)
                clientIdentity += "_" + httpChunk.version;
            if (httpChunk.encoding)
                url = (0, url_1.setUrlParam)(url, "te", httpChunk.encoding);
            if (httpChunk.compressionType)
                headers["Content-Encoding"] = httpChunk.compressionType;
        }
        headers["X-Kontur-Client-Identity"] = clientIdentity;
        headers["X-Kontur-Drive-Client-Version"] =
            DriveClientVersion.SupportQueryUrl;
        var request = {
            url: url,
            data: httpChunk && httpChunk.data,
            method: method,
            headers: headers,
            responseType: responseType,
        };
        return this.taskPool.run(function () {
            return _this.httpClient.send(request, token, progress);
        });
    };
    DriveHttpClient.prototype.noResponseError = function (innerError) {
        return new errors_1.CommonError("DriveHttpClient got no response", null, errors_1.ErrorCodes.NoHttpResponse, innerError);
    };
    return DriveHttpClient;
}(object_1.BaseObject));
exports.DriveHttpClient = DriveHttpClient;
var HttpTransferChunk = /** @class */ (function () {
    function HttpTransferChunk(data, version, compressionType, encoding) {
        this.version = version;
        this.data = data;
        this.compressionType = compressionType;
        this.encoding = encoding;
    }
    HttpTransferChunk.prototype.isDisposed = function () {
        return this.disposed;
    };
    HttpTransferChunk.prototype.dispose = function () {
        this.disposed = true;
        this.data = null;
    };
    return HttpTransferChunk;
}());
exports.HttpTransferChunk = HttpTransferChunk;
var DriveHttpDownloadResult = /** @class */ (function () {
    function DriveHttpDownloadResult() {
    }
    DriveHttpDownloadResult.prototype.isDisposed = function () {
        return this.disposed;
    };
    DriveHttpDownloadResult.prototype.dispose = function () {
        this.disposed = true;
        this.content = null;
    };
    return DriveHttpDownloadResult;
}());
exports.DriveHttpDownloadResult = DriveHttpDownloadResult;
